var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showEoPublishPanel)?_c('PublishByEoPanel',_vm._g(_vm._b({},'PublishByEoPanel',_vm.$attrs,false),_vm.$listeners)):(_vm.showStaffPublishPanel)?_c('PublishPanel',_vm._g(_vm._b({},'PublishPanel',_vm.$attrs,false),_vm.$listeners)):_c('div',[_vm._v("Access Denied")])
}
var staticRenderFns = []

export { render, staticRenderFns }